import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Car } from '../types/car'
import { Service } from '../types/service'
import { Package } from '../enums/package.enum'

export interface UserState {
  id: number | null
  username: string | null
  email: string | null
  phoneNumber: string | null
  cars: Car[]
  services: Service[]
  isEmailConfirmed: boolean
  isPhoneNumberConfirmed: boolean
  name: string | null
  taxId: string | null
  street: string | null
  city: string | null
  zipCode: string | null
  accountNumber: string | null
  package: Package | null
  packageExpiredAt: Date | null
  packageUsersNumber: number | null
  isSuperadmin?: boolean
  hadPremiumTrial: boolean
}

const initialState: UserState = {
  id: null,
  username: null,
  email: null,
  phoneNumber: null,
  cars: [],
  services: [],
  isEmailConfirmed: false,
  isPhoneNumberConfirmed: false,
  name: null,
  taxId: null,
  street: null,
  city: null,
  zipCode: null,
  accountNumber: null,
  package: null,
  packageExpiredAt: null,
  packageUsersNumber: null,
  isSuperadmin: false,
  hadPremiumTrial: true
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    set: (state: UserState, action: PayloadAction<UserState>) => {
      const { id, username, phoneNumber, email, isEmailConfirmed, isPhoneNumberConfirmed, cars, services, name, taxId, city, street, zipCode, accountNumber, packageExpiredAt, packageUsersNumber, isSuperadmin, hadPremiumTrial } = action.payload
      state.id = id
      state.username = username
      state.phoneNumber = phoneNumber
      state.email = email
      state.cars = cars
      state.services = services
      state.isEmailConfirmed = isEmailConfirmed
      state.isPhoneNumberConfirmed = isPhoneNumberConfirmed
      state.name = name
      state.taxId = taxId
      state.city = city
      state.street = street
      state.zipCode = zipCode
      state.accountNumber = accountNumber
      state.package = (packageExpiredAt != null) && packageExpiredAt < new Date() ? null : action.payload.package
      state.packageExpiredAt = packageExpiredAt
      state.packageUsersNumber = packageUsersNumber
      state.isSuperadmin = isSuperadmin
      state.hadPremiumTrial = hadPremiumTrial
    },
    reset: (state: UserState) => {
      state.id = null
      state.username = null
      state.phoneNumber = null
      state.email = null
      state.cars = []
      state.services = []
      state.isEmailConfirmed = false
      state.isPhoneNumberConfirmed = false
      state.name = null
      state.taxId = null
      state.city = null
      state.street = null
      state.zipCode = null
      state.accountNumber = null
      state.package = null
      state.packageExpiredAt = null
      state.packageUsersNumber = null
      state.isSuperadmin = false
      state.hadPremiumTrial = true
    }
  }
})

export const UserActions = userSlice.actions

export default userSlice.reducer
